module.exports = "<div id='app'>\n  <router-view>\n  </router-view>\n</div>  \n";


//////////////////
// WEBPACK FOOTER
// ./lib/boot/app.html
// module id = 41
// module chunks = 0